import React from 'react'
import { Box, Typography } from '@mui/material'
import MysteryShopperTable from './Table'
import Toolbar from './Toolbar'

const MysteryShopper = () => (
  <Box
    mb={8}
    textAlign='center'
    boxShadow={1}
    style={{ color: '#464646', background: 'whitesmoke' }}
  >
    <Box pt={6} pb={4}>
      <Typography variant='h2' gutterBottom={true}>
        Dealer
      </Typography>
      <Typography variant='h1' fontWeight={900} fontSize={36}>
        Mystery Shopper
      </Typography>
    </Box>

    <Toolbar></Toolbar>
    <MysteryShopperTable></MysteryShopperTable>
  </Box>
)

export default MysteryShopper
